import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'ap-page-content',
    templateUrl: './page-content.component.html',
    styleUrls: ['./page-content.component.css'],
    standalone: false
})
export class PageContentComponent implements OnInit {

  constructor() {}

  ngOnInit() {}

}
